import { Spinner } from "@components/healthemSpinner/healthemSpinner";
import { useRTEState } from "@components/richTextEditor/useRTEState";
import { getNoteMaxLength } from "@utils/helpers";
import { Button } from "antd";
import RichTextEditor from "@components/richTextEditor";
import './notePopup.scss';

export function NewNoteView({ viewType, loading, handleOk, description, setDescription, wordLimit = getNoteMaxLength(), handleCancel, showCustomControls = true }: any) {
  const { bookmarkStatus, setBookmarkStatus, recipientType, setRecipientType } = useRTEState();

  const customControlData = showCustomControls
    ? {
        showCustomControls: true,
        bookmarkStatus: bookmarkStatus,
        setBookmarkStatus: setBookmarkStatus,
        recipientType: recipientType,
        setRecipientType: setRecipientType,
      }
    : {
        showCustomControls: false,
      };

  const contentLength = description
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim().length;

  return (
    <div className="new-note-container" onClick={(e) => e.stopPropagation()}>
      <div className="note-header flex v-center">
        <h1 className="f16 w500" style={{ color: "#112a49" }}>
          {viewType} Note
        </h1>
      </div>
      <div className="note-body">
        <RichTextEditor
          content={description}
          changeHandler={setDescription}
          customControlData={customControlData}
          showCount={true}
          wordLimit={wordLimit}
        />
      </div>
      <div className="addd-note-footer">
        <Button type="default" size="large" className="cancel-button" onClick={handleCancel}>
          Cancel
        </Button>
        <Spinner loading={loading}>
          <Button type="primary" size="large" className="add-notes" onClick={handleOk} disabled={!contentLength || contentLength > wordLimit}>
            {viewType}
          </Button>
        </Spinner>
      </div>
    </div>
  );
}
